import { useTranslation } from 'react-i18next';
import { Dialog } from '@/shared/ui/dialogs/Dialog';
import { Button, type ButtonVariant } from '@/shared/ui/buttons/Button';

type ConfirmDialogProps = {
  open: boolean;
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: ButtonVariant;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ConfirmDialog = ({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel,
  confirmVariant = 'primary',
  loading = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) => {
  const { t } = useTranslation();
  return (
  <Dialog
    open={open}
    onClose={onCancel}
    title={title}
    description={description}
    size="sm"
    closeOnBackdrop={!loading}
    footer={
      <>
        <Button variant="outline" onClick={onCancel} disabled={loading}>
          {cancelLabel ?? t('common:cancel')}
        </Button>
        <Button variant={confirmVariant} onClick={onConfirm} loading={loading}>
          {confirmLabel ?? t('common:confirm')}
        </Button>
      </>
    }
  >
    <div />
  </Dialog>
  );
};
